import Decimal from "decimal.js";
import type { PublicGameConfig } from "@crashx/shared";

export type BetCurrency = PublicGameConfig["currencies"][number];
export const QUICK_AMOUNTS = ["1", "2", "5", "10"] as const;
export function moneyInput(value: string): Decimal | null {
  if (!/^\d{1,16}(?:\.\d{1,8})?$/.test(value)) return null;
  return new Decimal(value);
}
export function adjustAmount(value: string, step: string, currency: BetCurrency): string {
  return Decimal.max(
    currency.minBet,
    Decimal.min(currency.maxBet, (moneyInput(value) ?? new Decimal(currency.minBet)).plus(step)),
  ).toFixed(currency.decimals);
}
export function validBetSettings(
  amount: string,
  auto: string,
  currency: BetCurrency | undefined,
  balance: number | null,
  maxMultiplier: number,
): boolean {
  const money = moneyInput(amount);
  if (!currency || balance === null || !money || money.decimalPlaces() > currency.decimals) return false;
  const target = auto === "" ? null : moneyInput(auto);
  return (
    money.gte(currency.minBet) &&
    money.lte(currency.maxBet) &&
    money.lte(balance) &&
    (auto === "" || (target !== null && target.gte(1.01) && target.lte(maxMultiplier)))
  );
}
